import styled from '@emotion/styled';

import { CheckboxEnabled, CheckboxChecked, CheckboxDisabled } from '../../images';

interface Props {
  disabled?: boolean;
  checked: boolean;
}

const Icon = styled.img<{ disabledChecked: boolean; }>`
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 12px;
  ${({ disabledChecked }) => (disabledChecked && 'opacity: 0.2;')}
`;

export default function CheckIcon({ disabled = false, checked = false }: Props) {
  const getSrc = () => {
    if (checked) {
      return CheckboxChecked;
    }

    return disabled ? CheckboxDisabled : CheckboxEnabled;
  };

  return <Icon src={getSrc()} alt="" disabledChecked={disabled && checked} />;
}
